module.exports = __webpack_public_path__ + "static/img/fayuan-icon3.b8c889e2.png";